/********************************************************************/
/****************** 关于 Vue.js - cli 导入组件、插件 ******************/
/********************************************************************/

import Vue from 'vue';
import VueRouter from 'vue-router';

import AaaAaa001 from '../views/AaaAaa001.vue';
import AaaAaa002 from '../views/AaaAaa002.vue';
import AaaAaa003 from '../views/AaaAaa003.vue';
import AaaAaa004 from '../views/AaaAaa004.vue';
import AaaAaa005 from '../views/AaaAaa005.vue';
import AaaAaa006 from '../views/AaaAaa006.vue';

import BbbBbb001 from '../views/BbbBbb001.vue';

/********************************************************************/
/*********** 关于 Vue.js + vue-router.js 插件搭建单页面应用 ***********/
/********************************************************************/

Vue.use(VueRouter);

const routes = [
	
	{ path : "/",             component : AaaAaa001, meta: { title: 'MineWay' } },
    { path : "/Features",     component : AaaAaa002, meta: { title: 'MineWay' } },
    { path : "/Applications", component : AaaAaa003, meta: { title: 'MineWay' } },
    { path : "/Projects",     component : AaaAaa004, meta: { title: 'MineWay' } },
    { path : "/About",        component : AaaAaa005, meta: { title: 'MineWay' } },
    { path : "/Contact",      component : AaaAaa006, meta: { title: 'MineWay' } },
    
    { path : "/Projects/Project/:param_001",      component : BbbBbb001, meta: { title: 'MineWay' } , props : true },
    
];

const router = new VueRouter({
	routes
});

router.beforeEach((to, from, next) => {
    
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    
    next();
});

/********************************************************************/
/****************** 关于 Vue.js - cli 导出当前组件 ********************/
/********************************************************************/

export default router;
